import React__default from 'react';

var CompanyWebsite = function CompanyWebsite(_ref) {
  var websiteUrl = _ref.websiteUrl,
    websiteLabel = _ref.websiteLabel;
  return /*#__PURE__*/React__default.createElement("a", {
    "automation-id": "company-website",
    href: websiteUrl,
    target: "_blank",
    rel: "noreferrer",
    className: "truncate text-p-16/5 text-action-primary hover:underline",
    title: websiteUrl
  }, websiteLabel);
};

export { CompanyWebsite };
//# sourceMappingURL=company-website.esm.js.map
